export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  TEACHERS: '/teachers',
  STUDENTS: '/students',
  SUBJECTS: '/subjects',
  SECTIONS: '/sections',
  CONSTRAINTS: '/constraints',
  TIMETABLE: '/timetable',
  ADMIN_TIMETABLE: '/admin-timetable',
  EXAMS: '/exams',
  RESOURCES: '/resources',
  DISCIPLINE: '/discipline',
  ATTENDANCE: '/attendance',
  VIEW_TIMETABLE: '/view-timetable',
  REPORTS: '/reports',
  AUDIT_LOGS: '/audit-logs',
  SYSTEM_CONFIG: '/system-config',
  TEACHER_ATTENDANCE: '/teacher-attendance',
  MY_TIMETABLE: '/my-timetable',
  ASSIGNMENTS: '/assignments',
  GRADES: '/grades',
  ATTENDANCE_HISTORY: '/attendance-history',
  LEAVE_REQUESTS: '/leave-requests',
  NOTIFICATIONS: '/notifications',
  SETTINGS: '/settings',
  CHAT: '/chat',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  INSTRUCTIONS: '/instructions',
};
